import request from '@/utils/request'
var api = {}
api.list = function(params) {
  
  return request({
    url: '/sys_dic/getSysDicList',
    method: 'get',
    params: params
  })
}
// api.list_tree = function(params) {
//   return request({
//     url: '/sys_dic/getMultiLevelSysDicList',
//     method: 'get',
//     params: params
//   })
// }
api.list_tree = function(params) {
  return request({
    url: '/sys_dic/getSysDicList',
    method: 'get',
    params: params
  })
}
api.create = function(data) {
  return request({
    url: '/sys_dic',
    method: 'post',
    data
  })
}
api.update = function(data) {
  return request({
    url: '/sys_dic',
    method: 'put',
    data
  })
}
api.del = function(id) {
  return request({
    url: '/sys_dic',
    method: 'delete',
    params: { id: id }
  })
}

api.getProviderOrg = function() {
  return request({
    url: '/query/getProviderOrgListCanLive',
    method: 'get'
  })
}

export default api



// WEBPACK FOOTER //
// ./src/api/sys_dic.js